angular.module('picmonicng').directive('pathwaysResume', [
  'Tracks',
  'Pathways',
  'UserService',
  'PlaylistService',
  '$filter',
  '$state',
  '$modal',
  function (Tracks, Pathways, UserService, PlaylistService, $filter, $state, $modal) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.loading = false;

        scope.setTrack = function (track_id) {
          if (UserService.user.current_track_id != track_id) {
            UserService.user.playlist_mode = 'track';
            UserService.user.current_track_id = track_id;
            UserService.user.$update();
          }
        };

        scope.goToCard = function (track, card) {
          if (UserService.user.user_id) {
            if ($state.current.name) {
              $state.go('app.learn', { slug: card.slug });
            } else {
              location.href = '/learn/' + card.slug;
            }
          } else {
            scope.loading = false;
            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'below-nav modal-body-reduced',
              size: 'sm',
              scope: scope,
              backdrop: 'static',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return {
                    name: track.name,
                  };
                },
                market_id: function () {
                  return null;
                },
                copy: function () {
                  return null;
                },
                redirect: function () {
                  return '/learn/' + card.slug;
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          }
        };

        element.on('click', function (event) {
          event.stopPropagation(); //prevent ui-sref from firing on parent div
          scope.loading = true;
          if (UserService.user.user_id) {
            scope.setTrack(attrs.trackid);
            send_ga('event', 'Pathways', 'Track Resume');
          }

          if (attrs.trackid) {
            Tracks.get({ track_id: attrs.trackid }, function (track) {
              scope.last_viewed_card_id = track.last_viewed_card_id;
              Tracks.get({ track_id: attrs.trackid, resource: 'picmonics' }, function (trackpicmonics) {
                var last_viewed_card = $filter('filter')(trackpicmonics.cards, { id: scope.last_viewed_card_id });
                if (last_viewed_card.length > 0) {
                  scope.goToCard(trackpicmonics, last_viewed_card[0]);
                } else {
                  var ordered_cards = $filter('orderBy')(trackpicmonics.cards, 'sort_order');
                  scope.goToCard(trackpicmonics, ordered_cards[0]);
                }
              });
            });
          } else if (attrs.pathwayId) {
            // We can't do this yet... We need an endpoint to fetch
            // all Picmonics from a given pathway
          }
        });
      },
    };
  },
]);
